import { t } from 'i18n';
import { JSONObject } from '../types';

// @ts-ignore
export function translateObject(o) {
  if (
    typeof o === 'string' &&
    !ignorePrefixes.some((prefix) => o.startsWith(prefix))
  ) {
    return t(o);
  }

  if (typeof o === 'object') {
    // handle Array
    if (Array.isArray(o)) {
      // @ts-ignore
      return o.map((item) => translateObject(item));
    }

    // handle object
    const newObject: JSONObject = {};
    for (const [k, v] of Object.entries(o)) {
      newObject[k] = translateObject(v);
    }
    return newObject;
  }

  return o;
}

// if value is string and starts with one of these texts, return original value
const ignorePrefixes = ['http', 'tel:', 'mailto:'];
